import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('Social').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'stretch',
    width: '100%',
    gap: '32px',
    color: theme.colors.text.primary,
    textWrap: 'balance',
    overflowX: 'auto',
    height: '100%',
    paddingBottom: '192px',
    overflow: 'scroll',
    paddingTop: '5vh',
  },

  header: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100vw',

    // раскоментить если надо вернуть картинку
    // minHeight: '42vw',
    // backgroundImage: 'url(/assets/backgrounds/SocialBG.webp)',
    // backgroundPosition: 'top',
    // backgroundSize: 'cover',
  },

  titleText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '90%',
    textAlign: 'center',
    gap: '20px',
    color: theme.colors.text.primary,

    h1: {
      margin: '0',
      fontSize: theme.sizes.texts.fontSize.xl,

      fontFamily: 'Inter',
      fontWeight: '600',
      lineHeight: '40px',
    },

    p: {
      margin: '0',
      fontSize: theme.sizes.texts.fontSize.s,
      fontFamily: 'Inter',
      fontWeight: '350',
      lineHeight: theme.sizes.texts.lineHeight.m,

      color: theme.colors.text.secondary,
      span: {
        margin: '0',
        fontSize: theme.sizes.texts.fontSize.s,
        fontFamily: 'Inter',
        fontWeight: '450',
        lineHeight: theme.sizes.texts.lineHeight.m,

        color: theme.colors.text.primary,
      },
      div: {
        color: theme.colors.button.primary.background,
        display: 'inline',
        fontWeight: '550',
      },
    },
  },

  containerTitle: {
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: '470',
    textTransform: 'uppercase',
    lineHeight: theme.sizes.texts.lineHeight.s,

    color: theme.colors.text.secondary,
  },

  secondaryContainerValue: {
    fontFamily: 'Space Grotesk',
    fontSize: '22px',
    textTransform: 'uppercase',
    fontWeight: '540',
    color: theme.colors.text.primary,
  },

  tokenInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: '24px',
    padding: '20px',
    borderRadius: '12px',
    backgroundColor: '#B0B1B81F',

    span: {
      width: '100%',
      border: '1px solid var(--bg-bg-card, rgba(176, 177, 184, 0.12))',
    },
  },
  tokenInfoContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    justifyContent: 'space-between',
    gap: '12px',
  },

  dailyRewardContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'start',
    gap: '12px',
  },
  dailyReward: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'start',
    gap: '10px',
  },

  dailyRewardValue: {
    fontFamily: 'Space Grotesk',
    fontSize: '32px',
    lineHeight: '35px',
    fontWeight: '540',
    color: theme.colors.text.primary,
    textTransform: 'uppercase',
  },

  coinIcon: {
    width: '28px',
    height: '28px',
  },

  coinIconTwo: {
    width: '20px',
    height: '20px',
  },

  claimInfo: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'start',
    textAlign: 'start',

    fontSize: theme.sizes.texts.fontSize.s,
    lineHeight: theme.sizes.texts.lineHeight.m,

    fontWeight: '450',
    color: theme.colors.text.secondary,
  },

  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '90%',
    gap: '12px',
  },

  earnedInfo: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'center',
    gap: '12px',
  },

  earnedInfoValue: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  },

  friendsInfo: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
  },

  friendsInfoItem: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    alignItems: 'start',
    justifyContent: 'start',
    gap: '12px',
    width: '100%',
    height: '100%',
    borderRadius: '12px',
    backgroundColor: '#B0B1B81F',
  },

  buttonContainer: {
    width: '90%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
  },

  inviteBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '52px',
    borderRadius: '12px',
    padding: '14px 24px,',
  },

  copyBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '52px',
    borderRadius: '12px',
    padding: '15px,',
  },

  copySucceed: {
    // backgroundColor: 'rgb(24,125,33,10%)!important',
    backgroundColor: '#2b2b2e!important',
  },

  ambassador: {
    padding: '0px',
    margin: '0px',
    color: theme.colors.text.secondary,
    textAlign: 'center',
    fontWeight: '350',
    fontSize: theme.sizes.texts.fontSize.s,
  },

  user: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    zIndex: '3',

    position: 'relative',
    width: '100%',
    backgroundColor: '#B0B1B81F',
    padding: '4px 16px',
    overflow: 'hidden',
    borderRadius: '12px',
    marginBottom: '8px',

    cursor: 'pointer',

    '&[data-yourplace="true"]': {
      backgroundColor: '#2e2f33',
      padding: '12px 16px',
      borderRadius: '12px',

      position: 'fixed',
      width: '95%',
      bottom: '11vh',
      boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.9)',
      zIndex: '99',

      '&[data-isplus="true"]': {
        boxShadow: '0px 0px 6px 2px rgba(96, 125, 252, 0.4) inset',
      },
    },
  },

  userInfo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'start',
    width: '100%',
    gap: '8px',
    fontStyle: 'normal',
  },

  place: {
    width: '10vw',
    color: theme.colors.text.secondary,
    marginRight: '8px',
  },

  userName: {
    maxWidth: '170px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    paddingLeft: '8px',
  },

  friendsWrapper: {
    width: '100%',
  },
  gigibalance: {
    textAlign: 'center',
    textWrap: 'nowrap',
  },
  friendTitle: {
    fontSize: theme.sizes.texts.fontSize.l,
    fontWeight: '550',
  },
  noFriends: {
    fontSize: theme.sizes.texts.fontSize.m,
    fontWeight: '350',
    textAlign: 'center',
    paddingTop: '5vh',
    color: theme.colors.text.secondary,
  },

  referralList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },

  friendsHeader: {
    display: 'flex',
    flexDirection: 'row',
    color: theme.colors.text.secondary,
    paddingBottom: '12px',
    p: {
      padding: '0px',
      margin: '0px',
    },

    '& > :nth-child(1)': {
      width: '15%',
      textAlign: 'center',
    },
    '& > :nth-child(2)': {
      width: '65%',
      textAlign: 'left',
    },
    '& > :nth-child(3)': {
      width: '20%',
      textAlign: 'left',
    },
  },

  buttonsWrapper: {
    display: 'flex',
    width: '100%',
    gap: '8px',
  },
}))
